import { atom } from "recoil";

const basketState = atom({
    key: "basketState",
    default: {
        basket: {},
    },
});

export { basketState };